<script>
import AppBranding from '@/components/AppBranding'
import DemoVideo from '@/components/DemoVideo'
import Features from '@/components/Features'
import TitleSlot from '@/components/TitleSlot'
import TextSlot from '@/components/TextSlot'
import Waves from '@/components/Waves'
import Pricing from '@/components/Pricing'
import ScreenshotsMockup from '@/components/ScreenshotsMockup'
import AppFooter from '@/components/AppFooter'

export default
{
    name: 'home',

    render () 
    {
        return (
            <div id='home-view'>
                <app-branding />
                <div id='header-separator' />
                <demo-video />
                <features id='features' />
                <screenshots-mockup />
                <pricing id='pricing' />
                <app-footer />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
        AppBranding,
        Features,
        DemoVideo,
        TitleSlot,
        TextSlot,
        Pricing,
        ScreenshotsMockup,
        Waves,
        AppFooter
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#home-view
{
    min-height: 200vh;
    background: white;

    --margin: 0 5vw;
    .OnTablet({ --margin: 0 10vw; });
    .OnDesktop({ --margin: 0 20vw; });

    #header-separator
    {
        margin-top: 90vh;
        width: 100%;
    }

    .demo-video
    {
        padding-top: 20vh;
    }

    .features
    {
        margin: var(--margin);

        .waves
        {
            margin: 0 -5vw;

            .OnTablet({ margin: 0 -10vw; });
            .OnDesktop({ margin: 0 -20vw; });

            .content
            {
                margin: 10vh 5vw;

                .OnTablet({ margin: 5vh 10vw; });
                .OnDesktop({ margin: 5vh 20vw; });
            }
        }
    }
 
    & > .waves
    {
        .content
        {
            margin: var(--margin);
            padding-top: 10vh;
            padding-bottom: 10vh;
        }
    }

    .pricing, .screenshots-mockup
    {
        margin: var(--margin);
    }

    .features .feature, .screenshots-mockup, .pricing
    {
        margin-top: 20vh;

        .OnTablet({ margin-top: 10vh; });
    }

    .screenshots-mockup
    {
        margin-top: 20vh;
        margin-bottom: 20vh;
    }

    .app-footer
    {
        margin-top: 10vh;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue